<section class="portfolio-kpi-table-card" [ngClass]="'portfolio-kpi-table-card--' + mode">
  <header *ngIf="showHeader" class="portfolio-kpi-table-card-header">
    <h3>{{ title }}</h3>
    <div class="portfolio-kpi-table-card-icons">
      <ng-container *ngIf="hasInfoTooltip; else staticInfoIcon">
        <mat-icon
          svgIcon="info"
          class="portfolio-kpi-table-card-icon portfolio-kpi-table-card-icon--interactive"
          cdkOverlayOrigin
          #infoOrigin="cdkOverlayOrigin"
          (mouseenter)="onInfoEnter()"
          (mouseleave)="onInfoLeave()"
          (click)="onInfoToggle()"
        ></mat-icon>
        <cds-tooltip
          [origin]="infoOrigin"
          [open]="infoTooltipOpen"
          placement="left"
          [panelWidth]="256"
          [hasBackdrop]="false"
          (hovered)="onInfoEnter()"
          (unhovered)="onInfoLeave()"
        >
          <ng-template #tooltipContent>
            <div *ngIf="infoTooltipTitle" class="portfolio-kpi-table-card-info-tooltip-title">
              {{ infoTooltipTitle }}
            </div>
            <div>{{ infoTooltipText }}</div>
          </ng-template>
        </cds-tooltip>
      </ng-container>
      <ng-template #staticInfoIcon>
        <mat-icon svgIcon="info" class="portfolio-kpi-table-card-icon"></mat-icon>
      </ng-template>
      <button
        *ngIf="showExpandButton"
        type="button"
        class="portfolio-kpi-table-card-expand-btn"
        (click)="onExpand()"
      >
        <mat-icon svgIcon="enlarge" class="portfolio-kpi-table-card-icon"></mat-icon>
      </button>
    </div>
  </header>

  <div class="portfolio-kpi-table-card-content">
    <div class="portfolio-kpi-expanded-header-actions">
      <ng-content select="[kpiTableLeadingAction]"></ng-content>
      <group-menu
        [variant]="'kpi-expanded'"
        (group)="toggleGrouping($event)"
        (expandAll)="expandAllGroups()"
        (collapseAll)="collapseAllGroups()"
      ></group-menu>
    </div>

    <div class="portfolio-kpi-table-card-scroll" (scroll)="onTableScroll($event)">
      <table *ngIf="isGrouped" class="mat-mdc-table kpi-table-grouped">
        <ng-container *ngFor="let group of visibleGroupedData; trackBy: trackByGroup">
          <thead>
            <tr class="group-header">
              <th [attr.colspan]="groupedDisplayedColumns.length">
                <mat-icon
                  class="group-toggle-icon"
                  [class.group-toggle-icon--down]="group.expanded"
                  [class.group-toggle-icon--right]="!group.expanded"
                  (click)="toggleGroup(group)"
                  [svgIcon]="group.expanded ? 'arrowhead-down' : 'arrowhead-right'"
                ></mat-icon>
                <a
                  [routerLink]="['/portfolio/study-details', group.milestones[0].studySk]"
                  cdkOverlayOrigin
                  #groupProtocolOrigin="cdkOverlayOrigin"
                  (mouseenter)="onProtocolMouseEnter(group.milestones[0])"
                  (mouseleave)="onProtocolMouseLeave()"
                  (click)="$event.stopPropagation()"
                  class="group-protocol-link"
                >
                  <strong>{{ group.protocolNumber }}</strong>
                </a>
                <cds-tooltip
                  *ngIf="protocolTooltipElement === group.milestones[0]"
                  [origin]="groupProtocolOrigin"
                  [open]="protocolTooltipOpen"
                  placement="right"
                  [panelWidth]="256"
                  [hasBackdrop]="false"
                  (hovered)="onProtocolTooltipHover()"
                  (unhovered)="onProtocolTooltipLeave()"
                >
                  <ng-template #tooltipContent>
                    <div class="portfolio-kpi-table-card__tooltip-header">
                      {{ group.protocolNumber }}
                    </div>
                    <div class="portfolio-kpi-table-card__tooltip-body">
                      {{ protocolTooltipStudy?.protocolDesc || group.protocolNumber }}
                    </div>
                  </ng-template>
                </cds-tooltip>
                <span *ngIf="showGroupedClientLabel" class="group-client"
                  >— {{ group.parentClientName }}</span
                >
                <span class="group-count" (click)="toggleGroup(group)"
                  >({{ group.milestones.length }})</span
                >
              </th>
            </tr>
            <tr *ngIf="group.expanded" class="column-header">
              <th
                *ngFor="let column of groupedDisplayedColumns"
                [class.hoverable-header]="columnConfigurations[column]?.hasHeaderMenu"
                [class.align-right-cell]="column === 'varianceFromBaselineDays'"
              >
                {{ columnConfigurations[column]?.displayName }}
                <header-menu-milestone
                  *ngIf="columnConfigurations[column]?.hasHeaderMenu"
                  [field]="column"
                  [columnName]="column"
                  [currentSortColumn]="currentSortColumn"
                  [currentSortDirection]="currentSortDirection"
                  (sortRequested)="onMenuSort($event, column)"
                ></header-menu-milestone>
              </th>
            </tr>
          </thead>
          <tbody *ngIf="group.expanded">
            <tr *ngFor="let element of group.milestones; trackBy: trackByMilestone">
              <td
                *ngFor="let column of groupedDisplayedColumns"
                [class.align-right-cell]="column === 'varianceFromBaselineDays'"
              >
                <ng-container
                  *ngIf="columnConfigurations[column]?.hasCustomContent; else defaultCell"
                >
                  <ng-container [ngSwitch]="true">
                    <ng-container *ngSwitchCase="column === 'protocolNumber'">
                      <a
                        [routerLink]="['/portfolio/study-details', element.studySk]"
                        cdkOverlayOrigin
                        #protocolOrigin="cdkOverlayOrigin"
                        (mouseenter)="onProtocolMouseEnter(element)"
                        (mouseleave)="onProtocolMouseLeave()"
                      >
                        {{ element.protocolNumber !== 'NULL' ? element.protocolNumber : '' }}
                      </a>
                      <cds-tooltip
                        *ngIf="protocolTooltipElement === element"
                        [origin]="protocolOrigin"
                        [open]="protocolTooltipOpen"
                        placement="right"
                        [panelWidth]="256"
                        [hasBackdrop]="false"
                        (hovered)="onProtocolTooltipHover()"
                        (unhovered)="onProtocolTooltipLeave()"
                      >
                        <ng-template #tooltipContent>
                          <div class="portfolio-kpi-table-card__tooltip-header">
                            {{ element.protocolNumber }}
                          </div>
                          <div class="portfolio-kpi-table-card__tooltip-body">
                            {{ protocolTooltipStudy?.protocolDesc || element.protocolNumber }}
                          </div>
                        </ng-template>
                      </cds-tooltip>
                    </ng-container>
                    <ng-container *ngSwitchCase="column === 'status'">
                      <status-badge
                        [type]="'portfolioMilestonesStatus'"
                        [badgeKey]="toString(element[column])"
                      ></status-badge>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      {{ element[column] !== 'NULL' ? (element[column] ?? '') : '' }}
                    </ng-container>
                  </ng-container>
                </ng-container>
                <ng-template #defaultCell>
                  {{ element[column] !== 'NULL' ? (element[column] ?? '') : '' }}
                </ng-template>
              </td>
            </tr>
          </tbody>
        </ng-container>
      </table>

      <table
        *ngIf="!isGrouped"
        mat-table
        [dataSource]="dataSource"
        [trackBy]="trackByMilestone"
        class="mat-mdc-table"
      >
        <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
          <th
            mat-header-cell
            *matHeaderCellDef
            [class.hoverable-header]="columnConfigurations[column]?.hasHeaderMenu"
            [class.align-right-cell]="column === 'varianceFromBaselineDays'"
          >
            {{ columnConfigurations[column]?.displayName }}
            <header-menu-milestone
              *ngIf="columnConfigurations[column]?.hasHeaderMenu"
              [field]="column"
              [columnName]="column"
              [currentSortColumn]="currentSortColumn"
              [currentSortDirection]="currentSortDirection"
              (sortRequested)="onMenuSort($event, column)"
            ></header-menu-milestone>
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            [class.align-right-cell]="column === 'varianceFromBaselineDays'"
          >
            <ng-container *ngIf="columnConfigurations[column]?.hasCustomContent; else defaultCell">
              <ng-container [ngSwitch]="true">
                <ng-container *ngSwitchCase="column === 'protocolNumber'">
                  <a
                    [routerLink]="['/portfolio/study-details', element.studySk]"
                    cdkOverlayOrigin
                    #protocolOrigin="cdkOverlayOrigin"
                    (mouseenter)="onProtocolMouseEnter(element)"
                    (mouseleave)="onProtocolMouseLeave()"
                  >
                    {{ element.protocolNumber !== 'NULL' ? element.protocolNumber : '' }}
                  </a>

                  <cds-tooltip
                    *ngIf="protocolTooltipElement === element"
                    [origin]="protocolOrigin"
                    [open]="protocolTooltipOpen"
                    placement="right"
                    [panelWidth]="256"
                    [hasBackdrop]="false"
                    (hovered)="onProtocolTooltipHover()"
                    (unhovered)="onProtocolTooltipLeave()"
                  >
                    <ng-template #tooltipContent>
                      <div class="portfolio-kpi-table-card__tooltip-header">
                        {{ element.protocolNumber }}
                      </div>
                      <div class="portfolio-kpi-table-card__tooltip-body">
                        {{ protocolTooltipStudy?.protocolDesc || element.protocolNumber }}
                      </div>
                    </ng-template>
                  </cds-tooltip>
                </ng-container>
                <ng-container *ngSwitchCase="column === 'status'">
                  <status-badge
                    [type]="'portfolioMilestonesStatus'"
                    [badgeKey]="toString(element[column])"
                  ></status-badge>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  {{ element[column] !== 'NULL' ? (element[column] ?? '') : '' }}
                </ng-container>
              </ng-container>
            </ng-container>
            <ng-template #defaultCell>
              {{ element[column] !== 'NULL' ? (element[column] ?? '') : '' }}
            </ng-template>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</section>
